import React, { useMemo } from 'react'
import { getFlightLoyaltyProductType } from 'lib/flights/flightUtils'
import LoyaltyPoints from 'loyalty/components/LoyaltyPoints'

interface Props {
  flightDeal: App.FlightDeal;
}

function FlightDealPoints({ flightDeal }: Props) {
  const pointsEarnCalculationRequests = useMemo<Array<App.LoyaltyPointsEarnCalculationRequest>>(() => {
    const isDomestic = flightDeal.originCountry === flightDeal.destinationCountry
    const type = getFlightLoyaltyProductType(flightDeal.fareClass.toLowerCase() || '', isDomestic)

    return [{
      loyaltyProductType: type,
      price: flightDeal.perAdultPrice,
    }]
  }, [flightDeal])

  return (
    <LoyaltyPoints calculationRequests={pointsEarnCalculationRequests} calculationType="estimate" />
  )
}

export default FlightDealPoints
